import { GlobalClassKeys } from 'assets/jss/common-styles';
import { ContentMetadataGetDto, FileGetDto } from 'models/ApiModels';
import * as React from 'react';
import RenderVideoFile from './RenderVideoFile';
import { RenderYoutube } from './RenderYoutube';
import { WithTranslation, withTranslation } from 'react-i18next';
import { VideJsPlayerEvent } from 'components/VideoPlayer';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export interface RenderVideoEventsProps {
    onSeeking?: VideJsPlayerEvent;
    onSeeked?: VideJsPlayerEvent;
    onEnded?: VideJsPlayerEvent;
    onPlaying?: VideJsPlayerEvent;
    onPause?: VideJsPlayerEvent;
    onProgress?: VideJsPlayerEvent;
    onReady?: VideJsPlayerEvent;
}

export interface RenderVideoProps {
    file?: FileGetDto;
    metadata?: ContentMetadataGetDto;
    autoplay?: boolean;
}

export type RenderVideoType = RenderVideoProps & RenderVideoEventsProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const RenderVideo: React.FC<RenderVideoType> = (props) => {

    const { file, metadata } = props;

    if (file == null && metadata == null)
        return null;

    if (metadata && metadata.provider == "Vimeo") {
        return <div className={GlobalClassKeys.videoContainer} dangerouslySetInnerHTML={{ __html: metadata.embedHtml }}></div>;
    }

    if (metadata && metadata.provider == "YouTube") {
        return <RenderYoutube {...props} />;
    }

    return <RenderVideoFile {...props} />;

};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default withTranslation()(RenderVideo);